import { render, staticRenderFns } from "./DetailsEmbed.vue?vue&type=template&id=24e7320b"
import script from "./DetailsEmbed.vue?vue&type=script&lang=js"
export * from "./DetailsEmbed.vue?vue&type=script&lang=js"
import style0 from "./DetailsEmbed.vue?vue&type=style&index=0&id=24e7320b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports